var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrochip(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F0F2FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1656_4245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.75 26.25L25.5 19.5C23.25 14.25 20.25 14.25 20.25 14.25V19.5",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 18L18.53 18.344C17.9331 18.4636 17.3868 18.7619 16.9635 19.1993C16.5402 19.6367 16.2599 20.1926 16.16 20.793L16 21.771C15.931 22.185 15.7171 22.561 15.3966 22.8319C15.0761 23.1028 14.6697 23.251 14.25 23.25C13.8522 23.25 13.4706 23.408 13.1893 23.6893C12.908 23.9706 12.75 24.3522 12.75 24.75V26.844C12.7502 27.5266 12.9831 28.1887 13.4104 28.721C13.8376 29.2534 14.4336 29.6241 15.1 29.772L18 30.417C18.9711 30.633 19.8432 31.1647 20.48 31.929L23.25 35.25",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3936 33.0228L30.6786 23.7378",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 35.2502L32.925 25.5752",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.25 14.21C34.0826 13.2657 32.6265 12.7505 31.125 12.7505C29.6235 12.7505 28.1674 13.2657 27 14.21",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7188 16.771C29.3998 16.2206 30.2491 15.9204 31.1248 15.9204C32.0004 15.9204 32.8497 16.2206 33.5308 16.771",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.125 19.313C31.0255 19.313 30.9302 19.2735 30.8598 19.2032C30.7895 19.1328 30.75 19.0374 30.75 18.938C30.75 18.8385 30.7895 18.7431 30.8598 18.6728C30.9302 18.6025 31.0255 18.563 31.125 18.563",
    stroke: "#1429B8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.125 19.313C31.2245 19.313 31.3198 19.2735 31.3902 19.2032C31.4605 19.1328 31.5 19.0374 31.5 18.938C31.5 18.8385 31.4605 18.7431 31.3902 18.6728C31.3198 18.6025 31.2245 18.563 31.125 18.563",
    stroke: "#1429B8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 23.25C19.4005 23.25 19.3052 23.2105 19.2348 23.1402C19.1645 23.0698 19.125 22.9745 19.125 22.875C19.125 22.7755 19.1645 22.6802 19.2348 22.6098C19.3052 22.5395 19.4005 22.5 19.5 22.5",
    stroke: "#1429B8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 23.25C19.5995 23.25 19.6948 23.2105 19.7652 23.1402C19.8355 23.0698 19.875 22.9745 19.875 22.875C19.875 22.7755 19.8355 22.6802 19.7652 22.6098C19.6948 22.5395 19.5995 22.5 19.5 22.5",
    stroke: "#1429B8",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1656_4245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrochip);
export default __webpack_public_path__ + "static/media/microchip.083ef8d7c588a3d1ce112a7a73f45502.svg";
export { ForwardRef as ReactComponent };